<div class="home-page-component-wrapper">
  <div class="hero-img-container-w">
    <div class="hero-img-container-w_text-hero-lady-w">
      <div class="hero-img-container-w_text-hero-lady-w_text-w">
        <h1>{{'home-page.atrizult-consult' | translate}}</h1>
        <p>{{'home-page.headline-text' | translate}}</p>
      </div>

      <img src="../../../assets/images/home-hero-lady.png" alt="home lady">
    </div>

    <div class="hero-img-container-w_span-w">
      <span class="rect-class-purple" [attr.data-first]="'home-page.ar-advisory' | translate" [attr.data-second]="'home-page.ar-architecture' | translate"></span>
      <span class="rect-class-brown" [attr.data-first]="'home-page.ar-transformation' | translate" [attr.data-second]="'home-page.ar-technology' | translate"></span>
      <span class="rect-class-dark-brown" [attr.data-first]="'home-page.ar-results' | translate" [attr.data-second]="'home-page.ar-reliable' | translate"></span>
      <span class="rect-class-gray" [attr.data-first]="'home-page.ar-impact' | translate" [attr.data-second]="'home-page.ar-integration' | translate"></span>
      <span class="rect-class-light-brown" [attr.data-first]="'home-page.ar-zero-assumption' | translate"
            [attr.data-second]="'home-page.ar-zero-risk' | translate"></span>
      <span class="rect-class-dark-gray" [attr.data-first]="'home-page.ar-lifetime' | translate" [attr.data-second]="'home-page.ar-lifecycle' | translate"></span>
    </div>

    <div class="hero-img-container-w_lets-talk-btn-w">
      <app-button
        [label]="'home-page.lets-talk' | translate"
        [href]="'/consultation'"
      />
    </div>
  </div>

  <app-image-text-card-wrapper
    [buttonName]="'home-page.our-services' | translate"
    [buttonHref]="'/services'"
    [learnMoreHref]="'/services'"
    [headline]="'home-page.services' | translate"
    [learnMore]="'home-page.hps-learn-more' | translate"
    [services]="services"
  />

  <app-home-free-consultation />

  <app-home-hps-card />

  <app-home-team-cards />

  <app-home-client-feedback />
</div>
